export default __webpack_public_path__ + "static/media/Radomir Tinkov - Gilroy-Light.5ac18846.otf";